import { render, staticRenderFns } from "./mailings-stats-general.vue?vue&type=template&id=3a13f9e6&"
import script from "./mailings-stats-general.vue?vue&type=script&lang=js&"
export * from "./mailings-stats-general.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports